import React from 'react';
import styled from 'styled-components';
import CircularCrossIcon from '../../assets/icons/circular-cross.svg';
import CustomButton from '../CustomButton/CustomButton';
import { useTranslation } from 'react-i18next';
const SaveDialogBodyConainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .circular__check {
    margin-bottom: 22px;
  }

  .title {
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 14px;
    margin-top: 14px;

    text-align: center;
    letter-spacing: -1px;
  }

  p {
    text-align: center;
    word-break: break-word;

    @media only screen and (max-width: 768px) {
      width: 90%;
    }

    @media only screen and (min-width: 768px) {
      width: 80%;
    }

    @media only screen and (min-width: 1024px) {
      width: 70%;
    }
  }

  button {
    margin-top: 38px;
    margin-bottom: 54px;
  }
`;

const SaveDialogBody = ({ handleClose }) => {
  const  {t} = useTranslation()
  return (
    <SaveDialogBodyConainer>
      <img
        className="circular__cross"
        src={CircularCrossIcon}
        alt="close"
      />
      <h1 className="title">{t('Something is missing')}!</h1>
      <p>
        {t('Select which column you want you text field value to be saved in')}.
      </p>
      <CustomButton onClick={handleClose}>{t('Close and Fix')}</CustomButton>
    </SaveDialogBodyConainer>
  );
};

export default SaveDialogBody;
